"use client";

import { useEffect, useState } from "react";

type ScreenType = "mobile" | "laptop";

export const useScreenType = (breakpoint: number = 768): ScreenType => {
  const [screenType, setScreenType] = useState<ScreenType>(() => {
    if (typeof window !== "undefined") {
      return window.innerWidth < breakpoint ? "mobile" : "laptop";
    }
    return "laptop";
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenType(window.innerWidth < breakpoint ? "mobile" : "laptop");
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint]);

  return screenType;
};
